import { createApp } from 'vue'
import vue3GoogleLogin from 'vue3-google-login'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { setupI18n } from '@/i18n'
import LazyLoadImage from './components/LazyloadImage/index.js'
import '@/assets/iconfont/solid/iconfont.js'

const pinia = createPinia()

const app = createApp(App)
const rootComponent = app
  .use(router)
  .use(pinia)
  .use(setupI18n)
  .use(LazyLoadImage)
  .mount('#app')

rootComponent.$nextTick(() => {
  if (process.env.NODE_ENV !== 'production') {
    import('vconsole/dist/vconsole.min').then((vconsole) => {
      new vconsole.default()
    })
  }
})
